module.exports = __webpack_public_path__ + "static/img/oca-culture-report.45c4db6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/oca-culture-report.jpg
// module id = FU8h
// module chunks = 0